import { Params } from '@angular/router';

export const getKey = (params: Params) => new URLSearchParams(params).toString();
